export default __webpack_public_path__ + "static/media/illust_signin_signup.0c02c050.svg";